module.exports = __webpack_public_path__ + "img/BrandedQr.95de503b.png";